// -------------- Component for the home page of the application --------------------
// ----------------------------------------------------------------------------------

// import necessary libraries and hooks
// import the necessary components and styles for the home page
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import StockChart from './StockChart';
import MetricsPanel from './MetricsPanel';
import PanelWrapper from './PanelWrapper';
import './HomePage.css';

const HomePage = () => { // create the home page component
  const [selectedStock, setSelectedStock] = useState('AAPL'); // create a state to hold the selected stock
  const [timeframe, setTimeframe] = useState('2015-01-01|2025-12-31'); // create a state to hold the selected timeframe

  return (
    <div className="dashboard">
      {/* show the sidebar with the list of stocks and allow the user to select a stock */}
      <Sidebar selectedStock={selectedStock} onSelectStock={setSelectedStock} timeframe={timeframe} />
      <div className="main-content">

        {/* show the header with the selected stock and timeframe, and allow the user to change the timeframe */}
        <Header stockData={{ symbol: selectedStock }} timeframe={timeframe} onTimeframeChange={setTimeframe} />
        <div className="dashboard-grid">

          {/* show the first chart panel with the stock price chart for the selected stock and timeframe */}
          <PanelWrapper id="chart-price" className="grid-panel"> 
            <StockChart symbol={selectedStock} timeframe={timeframe} defaultColumn="PX_LAST" />
          </PanelWrapper>

          {/* show the macro panel with the key metrics for the selected stock and timeframe */}
          <PanelWrapper id="metrics" className="grid-panel"> 
            <MetricsPanel timeframe={timeframe} />
          </PanelWrapper>

          {/* show the second chart panel with the market cap chart for the selected stock and timeframe */}
          <PanelWrapper id="chart-mktcap" className="grid-panel"> 
            <StockChart symbol={selectedStock} timeframe={timeframe} defaultColumn="CUR_MKT_CAP" />
          </PanelWrapper>

          {/* show the third chart panel with the price to book ratio chart for the selected stock and timeframe */}
          <PanelWrapper id="chart-pb" className="grid-panel"> 
            <StockChart symbol={selectedStock} timeframe={timeframe} defaultColumn="PX_TO_BOOK_RATIO" />
          </PanelWrapper>

        </div>
      </div>
    </div>
  );
};

export default HomePage; // export the home page component
